<template>
  <v-icon>
    {{ svgPath }}
  </v-icon>
</template>

<script>
import { mdiChevronLeftCircleOutline } from "@mdi/js";
export default {
  name: "MdiChevronLeftCircleOutline",
  data() {
    return {
      svgPath: mdiChevronLeftCircleOutline,
    };
  },
};
</script>
